/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1LocationCountriesCountryidLangsMutationRequest,
  PostApiV1LocationCountriesCountryidLangsMutationResponse,
  PostApiV1LocationCountriesCountryidLangsPathParams,
  PostApiV1LocationCountriesCountryidLangs400,
  PostApiV1LocationCountriesCountryidLangs401,
  PostApiV1LocationCountriesCountryidLangs404,
  PostApiV1LocationCountriesCountryidLangs500,
} from "../../types/locationCountryLangController/PostApiV1LocationCountriesCountryidLangs.ts";

function getPostApiV1LocationCountriesCountryidLangsUrl(
  countryId: PostApiV1LocationCountriesCountryidLangsPathParams["countryId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/location/countries/${countryId}/langs` as const,
  };
  return res;
}

/**
 * @description Cria uma nova tradução (idioma) para o país informado. **(Requer Authorization para autenticação)**
 * @summary Criar idioma do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs}
 */
export async function postApiV1LocationCountriesCountryidLangs(
  countryId: PostApiV1LocationCountriesCountryidLangsPathParams["countryId"],
  data?: PostApiV1LocationCountriesCountryidLangsMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1LocationCountriesCountryidLangsMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1LocationCountriesCountryidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountriesCountryidLangs400
      | PostApiV1LocationCountriesCountryidLangs401
      | PostApiV1LocationCountriesCountryidLangs404
      | PostApiV1LocationCountriesCountryidLangs500
    >,
    PostApiV1LocationCountriesCountryidLangsMutationRequest
  >({
    method: "POST",
    url: getPostApiV1LocationCountriesCountryidLangsUrl(
      countryId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
